export const CARD_HEADER_SECTIONS = [
    { key: "video_request", label: "Video Requests", className: "video-requests-list", view: "Normal" },
    { key: "on_hold", label: "On Hold", className: "hold-list", view: "Normal" },
    { key: "editing", label: "Editing", className: "editing-list", view: "Normal" },
    { key: "qa", label: "Quality Check", className: "qa-list", view: "Normal" },
    { key: "done", label: "Done", className: "done-list", view: "Normal & YT Helper" },
    { key: "canceled", label: "Canceled", className: "canceled-list", view: "Normal & YT Helper" },
    { key: "repurposing", label: "Repurposing", className: "repurpose-list", view: "Normal" },
    { key: "yt_assigned", label: "Assigned", className: "assigned-card-list", view: "YT Helper" },
    { key: "yt_in_progress", label: "In Progress", className: "in-progress-card-list", view: "YT Helper" },
];

export function normalizeCardHeaderColors(raw) {
    let stored = raw;
    if (typeof stored === "string") {
        try {
            stored = JSON.parse(stored);
        } catch (e) {
            stored = null;
        }
    }
    if (!stored || typeof stored !== "object") {
        stored = {};
    }
    const sections = {};
    CARD_HEADER_SECTIONS.forEach(({ key }) => {
        const entry = (stored.sections && stored.sections[key]) || {};
        sections[key] = {
            background: entry.background || null,
            text: entry.text || null,
        };
    });
    return {
        primary_color: stored.primary_color || null,
        secondary_color: stored.secondary_color || null,
        sections,
    };
}

export function buildCardHeaderColorCss(raw) {
    const colors = normalizeCardHeaderColors(raw);
    const selectorFor = (className) => `.${className} .cardList .collapsible-header`;
    const rules = [];
    if (colors.primary_color || colors.secondary_color) {
        const allSelectors = CARD_HEADER_SECTIONS.map(({ className }) => selectorFor(className)).join(",\n");
        const props = [];
        if (colors.primary_color) {
            props.push(`background-color: ${colors.primary_color} !important;`);
        }
        if (colors.secondary_color) {
            props.push(`color: ${colors.secondary_color} !important;`);
        }
        rules.push(`${allSelectors} {\n${props.join("\n")}\n}`);
    }
    CARD_HEADER_SECTIONS.forEach(({ key, className }) => {
        const entry = colors.sections[key];
        const props = [];
        if (entry.background) {
            props.push(`background-color: ${entry.background} !important;`);
        }
        if (entry.text) {
            props.push(`color: ${entry.text} !important;`);
        }
        if (props.length) {
            rules.push(`${selectorFor(className)} {\n${props.join("\n")}\n}`);
        }
    });
    return rules.join("\n");
}
